<select #element [(ngModel)]="model" [multiple]="multiple" autocomplete="off" [attr.placeholder]="placeholder">
  <option value="" disabled>{{ placeholder }}</option>
  @for (opt of data; track opt) {
    <option [ngValue]="opt.id">
      {{ opt.text }}
    </option>
  }
</select>
